function createDraftDrawerScrollLock({ document, window, MutationObserver }) {
  const details = document.querySelector('.ds-navigation-header #Details-menu-drawer-container');
  if (!details) return { sync() {} };
  const body = document.body;
  const properties = ['position', 'top', 'left', 'width', 'overflow'];
  let saved = null;
  function lock() {
    if (saved) return;
    saved = {
      x: window.scrollX, y: window.scrollY,
      styles: properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)])
    };
    body.style.setProperty('position', 'fixed');
    body.style.setProperty('top', `${-saved.y}px`);
    body.style.setProperty('left', `${-saved.x}px`);
    body.style.setProperty('width', '100%');
    body.style.setProperty('overflow', 'hidden');
  }
  function unlock() {
    if (!saved) return;
    const previous = saved;
    saved = null;
    previous.styles.forEach(([name, value, priority]) => {
      if (value) body.style.setProperty(name, value, priority);
      else body.style.removeProperty(name);
    });
    const root = document.documentElement.style;
    const behavior = root.getPropertyValue('scroll-behavior');
    const priority = root.getPropertyPriority('scroll-behavior');
    root.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(previous.x, previous.y);
    if (behavior) root.setProperty('scroll-behavior', behavior, priority);
    else root.removeProperty('scroll-behavior');
  }
  function sync() {
    if (details.open) lock();
    else unlock();
  }
  document.addEventListener('click', event => {
    const summary = event.target.closest('summary');
    if (summary === details.querySelector(':scope > summary') && !details.open) lock();
  }, true);
  new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
  sync();
  return { sync };
}

function createDraftNavigationBreakpointCleanup({ document, window, menus, closeMenus, closeDrawers, getCart, isCartOpen }) {
  const breakpoint = window.matchMedia?.('(min-width: 990px)');
  if (!breakpoint) return { destroy() {} };
  let desktop = breakpoint.matches;
  function change(event) {
    if (event.matches === desktop) return;
    desktop = event.matches;
    const drawerOpen = [...document.querySelectorAll('.ds-navigation-header header-drawer')].some(drawer => drawer.mainDetailsToggle?.open);
    const menuOpen = menus().some(menu => menu.mainDetailsToggle?.open);
    const searches = [...document.querySelectorAll('.ds-navigation-header .header__search details-modal, .ds-navigation-header details-modal.header__search')].filter(modal => modal.isOpen?.());
    const cartOpen = isCartOpen();
    if (!drawerOpen && !menuOpen && !searches.length && !cartOpen) return;
    closeMenus();
    closeDrawers(event);
    searches.forEach(modal => modal.close(false));
    if (cartOpen && typeof getCart()?.hide === 'function') getCart().hide();
    const selector = cartOpen ? '#cart-icon-bubble' : searches.length ? '.ds-navigation-header .header__icon--search' : desktop ? '.ds-navigation-header #Details-HeaderMenu-ds-shop > summary' : '.ds-navigation-header #Details-menu-drawer-container > summary';
    document.querySelector(selector)?.focus({ preventScroll: true });
  }
  if (breakpoint.addEventListener) breakpoint.addEventListener('change', change);
  else breakpoint.addListener(change);
  return { destroy() { if (breakpoint.removeEventListener) breakpoint.removeEventListener('change', change); else breakpoint.removeListener(change); } };
}

/* Complete the native HeaderMenu dismissal lifecycle without replacing it. */
(function () {
  'use strict';
  const scrollLock = window.MutationObserver ? createDraftDrawerScrollLock({ document, window, MutationObserver: window.MutationObserver }) : null;
  const menus = () => [...document.querySelectorAll('header-menu[data-ds-navigation]')];
  function close(menu) {
    if (menu.mainDetailsToggle?.open) menu.close();
  }
  document.addEventListener('click', event => {
    menus().forEach(menu => {
      if (!menu.contains(event.target)) close(menu);
      else if (event.target.closest('a[href]')) close(menu);
    });
  });
  let cartOpen = false;
  document.addEventListener('rebuy:smartcart.show', () => { cartOpen = true; menus().forEach(close); });
  document.addEventListener('rebuy:smartcart.hide', () => { cartOpen = false; });
  document.addEventListener('toggle', event => {
    const owner = event.target.closest?.('header-menu[data-ds-navigation]');
    if (owner && event.target === owner.mainDetailsToggle && event.target.open) {
      menus().filter(menu => menu !== owner).forEach(close);
    }
  }, true);
  function closeDrawers(event) {
    document.querySelectorAll('.ds-navigation-header header-drawer').forEach(drawer => {
      if (!drawer.mainDetailsToggle?.open) return;
      drawer.closeMenuDrawer(event, false);
      drawer.mainDetailsToggle.removeAttribute('open');
      drawer.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
    scrollLock?.sync();
  }
  document.addEventListener('click', event => {
    if (event.target.closest('.ds-navigation-header header-drawer a[href]') ||
        event.target.closest('.ds-navigation-header .header__icon--search')) closeDrawers(event);
  }, true);
  window.addEventListener('pagehide', event => { menus().forEach(close); closeDrawers(event); });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    menus().forEach(close);
    closeDrawers(event);
  });
  createDraftNavigationBreakpointCleanup({ document, window, menus, closeMenus: () => menus().forEach(close), closeDrawers, getCart: () => window.Rebuy?.SmartCart, isCartOpen: () => cartOpen });
}());
